/**
 * List Scroll Color Animation
 * Add this to your theme's JavaScript file or enqueue it separately
 */

(function() {
    'use strict';

    // Initialize the scroll animation for all list-scroll sections
    function initListScrollAnimations() {
        const sections = document.querySelectorAll('.list-scroll');
        
        sections.forEach(function(section, sectionIndex) {
            const listElement = section.querySelector('.list');
            
            if (!listElement) return;

            // Create unique IDs if they don't exist
            if (!section.id) {
                section.id = 'listScrollSection' + sectionIndex;
            }
            if (!listElement.id) {
                listElement.id = 'animatedList' + sectionIndex;
            }

            // Split text into individual words while preserving spaces
            const text = listElement.textContent.trim();
            const parts = text.split(/(\s+|•)/); // Split on spaces and bullets, keeping delimiters
            
            // Clear original content and rebuild with spans
            listElement.innerHTML = '';
            let wordIndex = 0;
            
            parts.forEach(function(part) {
                if (part.trim() === '') {
                    // This is whitespace, add it directly
                    listElement.appendChild(document.createTextNode(part));
                } else {
                    // This is a word or bullet, wrap it in a span
                    const span = document.createElement('span');
                    span.className = 'list-word';
                    span.textContent = part;
                    span.dataset.index = wordIndex;
                    listElement.appendChild(span);
                    wordIndex++;
                }
            });

            const wordElements = listElement.querySelectorAll('.list-word');
            
            // Scroll event handler for this specific section
            function handleScroll() {
                const sectionRect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                
                // Calculate section position
                const sectionTop = sectionRect.top;
                const sectionHeight = sectionRect.height;
                
                // Start animation when section is 1/2 way through viewport (50% from top)
                // End animation when section is 1/3 way through viewport (33% from top)
                const animationStartPoint = windowHeight * 0.5;  // Start at 50% down screen
                const animationEndPoint = windowHeight * 0.33;   // End at 33% down screen
                
                // Calculate total animation distance (section height + viewport travel distance)
                const viewportTravelDistance = animationStartPoint - animationEndPoint;
                const totalAnimationDistance = sectionHeight + viewportTravelDistance;
                
                // Calculate progress based on how much the section has traveled through the animation zone
                let progress = 0;
                
                if (sectionTop <= animationStartPoint) {
                    // Section has entered the animation zone
                    const distanceTraveled = animationStartPoint - sectionTop;
                    progress = Math.max(0, Math.min(1, distanceTraveled / totalAnimationDistance));
                }
                
                // Apply fade-in effect to words based on progress
                const totalWords = wordIndex; // Use actual word count, not total elements
                const wordsToShow = Math.floor(progress * totalWords);
                
                wordElements.forEach(function(word) {
                    const wordDataIndex = parseInt(word.dataset.index);
                    if (wordDataIndex < wordsToShow) {
                        word.classList.add('fade-in');
                    } else {
                        word.classList.remove('fade-in');
                    }
                });
            }

            // Store the handler for this section
            section._scrollHandler = handleScroll;
        });

        // Global scroll handler that calls all section handlers
        function globalScrollHandler() {
            sections.forEach(function(section) {
                if (section._scrollHandler) {
                    section._scrollHandler();
                }
            });
        }

        // Throttle scroll events for better performance
        let ticking = false;
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(function() {
                    globalScrollHandler();
                    ticking = false;
                });
                ticking = true;
            }
        }

        // Add scroll listener
        window.addEventListener('scroll', requestTick, { passive: true });
        
        // Initial check for all sections
        globalScrollHandler();
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initListScrollAnimations);
    } else {
        initListScrollAnimations();
    }

    // Also initialize on window load to catch any late-loaded content
    window.addEventListener('load', initListScrollAnimations);

})();